export const AppMap = {
  思睿教育集团: {
    appId: 'cli_a0280c18ac38900c',
  },
  SavvyGroup2023: {
    appId: 'cli_a413015b67b8d00d',
    giftCourseApprovalCode: 'CB065F2D-79EC-4F06-9D98-2601DB93B7CD',
    orderApprovalCode: '39C0BC76-5CD4-4807-9FBF-0036FD77684B',
    giftCourseCCNodeId: 'fddeb551914275a97359d6a9c04099d8',
    hasFreeCourses: { 是: 'lj05t1d7-cngh2z3yca5-0', 否: 'lj05vmsy-85n8pk2xd1w-1' },
    giftPoints: { 是: 'lj05suss-4cc4qap8obm-0', 否: 'lj05wn1s-pgwh7d952ec-1' },
    orderccListNodeId: 'de4d9bcb314c72a00333a3e7cb917f63',
  },
  SavvyGroup: {
    appId: 'cli_a16d97844bf8d00b',
    giftCourseApprovalCode: 'BE1C4826-FDF0-4D0D-A0AC-2002AB65654E',
    giftCourseCCNodeId: '67b6f5752a755bdd00867bed1b2ef3f5',
    orderApprovalCode: '3A0BCB24-35F6-43B9-8A03-A088084E3EB3',
    hasFreeCourses: { 是: 'l1peswyp-60b2s063xqd-0', 否: 'l1pet8oq-zwt204i43bs-1' },
    giftPoints: { 是: 'l1petqbc-0skf7gvh2zhm-0', 否: 'l1petqbm-o2huibg5iv-1' },
    orderccListNodeId: 'ac70ecaee588e204d97b38565a3aa83b',
  },
  SavvyGroup2025: {
    appId: 'cli_a740cc003d3b1013',
    orderApprovalCode: '514E0AB0-EC3B-4DEB-8CE9-5D8B0F69C859',
    hasFreeCourses: { 是: 'm908qtcc-r0rtyuh0y9b-0', 否: 'm908qtch-bfa2any05oq-1' },
    giftPoints: { 是: 'm908s367-kqd2i3erdf9-0', 否: 'm908s367-ixo5kwop5j-0' },
    orderccListNodeId: '57b07341d322048db66ea3edf6e35a00',
  },
};
